import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const SignupSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to book site after 8 seconds
    const timer = setTimeout(() => {
      window.location.href = 'https://www.coltureplaybook.com';
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="min-h-[80vh] flex items-center justify-center px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <svg
              className="w-24 h-24 mx-auto mb-6"
              fill="none"
              stroke="#FF4F00"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          
          <h1 className="hero-title text-5xl md:text-7xl mb-6">
            YOU'RE IN!
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground mb-8 leading-relaxed">
            You've secured your spot for priority ticket access to the Colture Playbook Tour. 
            We'll notify you as soon as tour dates are announced for your city.
          </p>

          <div className="bg-secondary p-8 md:p-12 mb-8">
            <p className="caption-text text-muted-foreground mb-4">WHILE YOU'RE HERE</p>
            <h2 className="section-title text-3xl mb-4">GET THE BOOK</h2>
            <p className="text-lg text-muted-foreground mb-6">
              Don't wait for the tour! Get your copy of the Colture Playbook today.
            </p>
            <a
              href="https://www.coltureplaybook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-block"
              data-testid="buy-book-btn"
            >
              BUY NOW
            </a>
            <p className="text-sm text-muted-foreground mt-4">
              Redirecting to the book site in a few seconds...
            </p>
          </div>

          <button
            onClick={() => navigate('/')}
            className="btn-secondary"
            data-testid="back-home-btn"
          >
            BACK TO HOME
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;